/**
 * Criteria type values for recruiting/test group criteria.
 */
export const CRITERIA_TYPES = {
  PROFILE_QUESTION: 'ProfileQuestion',
  PROFILE_PROPERTY: 'ProfileProperty',
  CUSTOM_TAG: 'CustomTag',
} as const;
